import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftContentTemplateServer } from "namirasoft-content-template";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftEmailSenderServer } from "namirasoft-email-sender";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftSlackSenderServer } from "namirasoft-slack-sender";
import { NamirasoftSMSSenderServer } from "namirasoft-sms-sender";
import { NamirasoftTeamsSenderServer } from "namirasoft-teams-sender";
import { NamirasoftTelegramSenderServer } from "namirasoft-telegram-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ContentTemplateLayout } from "./ContentTemplateLayout";
import { ContentTemplateRoutes } from "./ContentTemplateRoutes";
import ContentEditPage from "./pages/ContentEditPage";
import ContentListPage from "./pages/ContentListPage";
import ContentViewPage from "./pages/ContentViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import MakePage from "./pages/MakePage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_CONTENT_TEMPLATE}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_CONTENT_TEMPLATE = new EnvService("REACT_APP_BASE_URL_CONTENT_TEMPLATE", true).getString();
            let REACT_APP_BASE_URL_SMS_SENDER = new EnvService("REACT_APP_BASE_URL_SMS_SENDER", true).getString();
            let REACT_APP_BASE_URL_EMAIL_SENDER = new EnvService("REACT_APP_BASE_URL_EMAIL_SENDER", true).getString();
            let REACT_APP_BASE_URL_TELEGRAM_SENDER = new EnvService("REACT_APP_BASE_URL_TELEGRAM_SENDER", true).getString();
            let REACT_APP_BASE_URL_TEAMS_SENDER = new EnvService("REACT_APP_BASE_URL_TEAMS_SENDER", true).getString();
            let REACT_APP_BASE_URL_SLACK_SENDER = new EnvService("REACT_APP_BASE_URL_SLACK_SENDER", true).getString();

            let content_template = new NamirasoftContentTemplateServer(REACT_APP_BASE_URL_CONTENT_TEMPLATE, result.account.token_manager, result.notifier.onError);
            let sms_sender = new NamirasoftSMSSenderServer(REACT_APP_BASE_URL_SMS_SENDER, result.account.token_manager, result.notifier.onError);
            let email_sender = new NamirasoftEmailSenderServer(REACT_APP_BASE_URL_EMAIL_SENDER, result.account.token_manager, result.notifier.onError);
            let telegram_sender = new NamirasoftTelegramSenderServer(REACT_APP_BASE_URL_TELEGRAM_SENDER, result.account.token_manager, result.notifier.onError);
            let teams_sender = new NamirasoftTeamsSenderServer(REACT_APP_BASE_URL_TEAMS_SENDER, result.account.token_manager, result.notifier.onError);
            let slack_sender = new NamirasoftSlackSenderServer(REACT_APP_BASE_URL_SLACK_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { content_template, sms_sender, email_sender, telegram_sender, teams_sender, slack_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={ContentTemplateRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={ContentTemplateRoutes.ContentList} element={<ContentListPage {...result} servers={servers} />} />
                            <Route path={ContentTemplateRoutes.ContentNew} element={<ContentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ContentTemplateRoutes.ContentView(":id")} element={<ContentViewPage {...result} servers={servers} />} />
                            <Route path={ContentTemplateRoutes.ContentEdit(":id")} element={<ContentEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ContentTemplateRoutes.ContentCopy(":id")} element={<ContentEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ContentTemplateRoutes.Make(null)} element={<MakePage {...result} servers={servers} />} />
                            <Route path={ContentTemplateRoutes.Make(":id")} element={<MakePage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={ContentTemplateRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <ContentTemplateLayout {...props}>
                {props.children}
            </ContentTemplateLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;